import config from '../utils/config';
import { ApiService } from '.';
import { ILesson } from '../interfaces';

const { API_ENDPOINT } = config;

export default class LessonService {
    // Initializing important variables
    private API = new ApiService();
    private URL = `${API_ENDPOINT}/lessons/`;

    public async getOne(id: number): Promise<ILesson> {
        const res = await this.API.client.get(`${this.URL}${id}/`);
        return Promise.resolve(res);
    }

    public async getAll(page: number = 1): Promise<any> {
        const res = await this.API.client.get(`${this.URL}?page=${page < 1 ? 1 : page}`);
        return Promise.resolve(res);
    }

    public async add(payload: any): Promise<ILesson> {
        const res = await this.API.client.post(this.URL, payload);
        return Promise.resolve(res);
    }

    public async update(payload: any): Promise<ILesson> {
        const res = await this.API.client
            .put(`${this.URL}${payload.id}/`, payload);
        return Promise.resolve(res);
    }
}
